"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupTypes = void 0;
var GroupTypes = {
  Public: 'public',
  Private: 'private'
};
exports.GroupTypes = GroupTypes;